// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"639e8b95","977":"3e5f909b"}[chunkId] + ".chunk.js";
};